import {AdminUserInfoCard} from './AdminUserInfoCard';

export default AdminUserInfoCard;
